import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'logzy-requestor-dialog',
  templateUrl: './requestor-dialog.component.html',
  styleUrls: ['./requestor-dialog.component.scss']
})
export class RequestorDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<RequestorDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }
  displayedColumns: string[] = ['created_at', 'value'];
  requestorData: MatTableDataSource<any>;

  ngOnInit(): void {
      this.requestorData = new MatTableDataSource([this.data]);
    // this.requestorData = new MatTableDataSource(this.data);
    console.log("print data", this.requestorData)

  }

}
